var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isAddress } from '@ethersproject/address';
import { Collapse, FormHelperText } from '@mui/material';
import { forwardRef, useEffect } from 'react';
import { useFormContext, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SwapFormKey, useWallet, useWidgetConfig } from '../../providers';
import { DisabledUI } from '../../types';
import { Card, CardTitle } from '../Card';
import { FormControl, Input } from './SendToWallet.style';
import { useSendToWalletStore } from './store';
export const SendToWallet = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const { disabledUI } = useWidgetConfig();
    const showSendToWallet = useSendToWalletStore((state) => state.showSendToWallet);
    const { account, provider } = useWallet();
    const { register, trigger } = useFormContext();
    useEffect(() => {
        trigger(SwapFormKey.ToAddress);
    }, [account.chainId, trigger]);
    if (disabledUI === null || disabledUI === void 0 ? void 0 : disabledUI.includes(DisabledUI.ToAddress)) {
        return null;
    }
    const { onChange, onBlur, name, ref: inputRef, } = register(SwapFormKey.ToAddress, {
        validate: (value) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                if (!value) {
                    return true;
                }
                const address = yield (provider === null || provider === void 0 ? void 0 : provider.resolveName(value));
                return (isAddress(address || value) ||
                    t('swap.error.title.walletAddressInvalid'));
            }
            catch (_a) {
                return t('swap.error.title.walletEnsAddressInvalid');
            }
        }),
        onBlur: () => trigger(SwapFormKey.ToAddress),
    });
    return (_jsx(Collapse, Object.assign({ timeout: 225, in: showSendToWallet, mountOnEnter: true, unmountOnExit: true }, { children: _jsxs(Card, Object.assign({}, props, { ref: ref }, { children: [_jsx(CardTitle, { children: t('swap.sendToWallet') }), _jsxs(FormControl, Object.assign({ fullWidth: true, sx: { paddingTop: '6px', paddingBottom: '5px' } }, { children: [_jsx(Input, { ref: inputRef, size: "small", autoComplete: "off", autoCorrect: "off", autoCapitalize: "off", spellCheck: "false", onChange: onChange, onBlur: onBlur, name: name, placeholder: t('swap.walletAddressOrEns') }), _jsx(SendToWalletFormHelperText, {})] }))] })) })));
});
export const SendToWalletFormHelperText = () => {
    var _a;
    const { errors } = useFormState();
    return (_jsx(FormHelperText, Object.assign({ error: !!errors.toAddress }, { children: (_a = errors.toAddress) === null || _a === void 0 ? void 0 : _a.message })));
};
